@if (rimsStepInfo) {
  <div class="rims-card-content">
    <h3 class="h3-medium">
      <span>{{ rimsStepInfo.stepId }}</span> - {{ rimsStepInfo.stepName }}
    </h3>
    <p class="body-small">{{ rimsStepInfo.description }}</p>
  </div>

  <div class="rims-card-controls">
    @if (this.incidentsPageStore?.isEditMode()) {
      <button
        class="button-secondary-icon"
        mat-icon-button
        disableRipple
        color="primary"
        (click)="onRemoveClickedAsync()"
      >
        <mat-icon>delete</mat-icon>
      </button>
    }

    <button class="button-secondary" mat-flat-button color="primary" (click)="onDetailsClickedAsync()">Details</button>
  </div>
}
